import React from "react";
import "./reviews.css";

const Reviews = () => {
	return (
		<section className="reviews">
			<div className="section-title">
				<span className="sub-title">Bewertungen</span>
				<h1 className="title">Das sagen unsere Kunden über uns</h1>
			</div>
			<div className="container">
				<div className="cards">
					<div className="card">
						<span className="date">07 Januar, 2023</span>
						<p className="desc">
							Mit aufrichtigem Dank für die liebevolle Pflege meiner Eltern über
							so lange Zeit. Sie freuten sich immer sehr, wenn sie kamen. Es war
							ein schönes Gefühl, dass Sie uns vermittelten.
						</p>
						<h3 className="title">Mobile Pflege</h3>
					</div>
					<div className="card">
						<span className="date">12 Dezember, 2022</span>
						<p className="desc">
							Wir sagen Danke ... Für den wundervollen Umgang mit unserem Opa,
							für ein Lächeln am frühen Morgen, für die Geduld in schwierigen
							Stunden, für ein aufmunterndes Gespräch mit der Oma.
						</p>
						<h3 className="title">Wohngemeinschaft</h3>
					</div>
					<div className="card">
						<span className="date">23 März, 2023</span>
						<p className="desc">
							Danke für die tolle Unterstützung. Ihre Hilfestellung im gesamten
							Bereich der Pflege und Betreuung hat mir wieder Kraft und
							Lebensenergie geschenkt.
						</p>
						<h3 className="title">Tagespflege</h3>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Reviews;
